import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { ROUTES } from "constants/routes"
import OnboardingLayout from "./OnboardingLayout"

const OnboardingSuccess = () => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = `${t("Registration complete")} | Wulooj`
  }, [t])

  return (
    <OnboardingLayout showHeaderActions={false}>
      <div className="onboarding-card text-center">
        <div className="mb-3">
          <i
            className="bx bx-check-circle text-success"
            style={{ fontSize: "4rem" }}
          />
        </div>
        <h4 className="mb-2">{t("You're all set!")}</h4>
        <p className="text-muted mb-4">
          {t(
            "Your tenant account is active. Check your email for login instructions and set your password."
          )}
        </p>
        <Link to={ROUTES.LOGIN} className="btn btn-primary px-4">
          {t("Go to Login")}
        </Link>
      </div>
    </OnboardingLayout>
  )
}

export default OnboardingSuccess
